import { defineStyleConfig } from '@chakra-ui/system';

const newStyle = {
    container: {
        alignItems: 'flex-begin',
    },
    control: {
        marginTop: 1,
        _checked: {
            backgroundColor: 'slt-pepper.1000',
            borderColor: 'slt-pepper.1000',
            _hover: {
                bg: 'slt-pepper.1000',
                borderColor: 'slt-pepper.1000',
            },
        },
    },
    label: {
        textStyle: 'body-base',
        color: 'slt-pepper.1000',
        fontFamily: 'TT Norms Pro',
    },
};

// When we fully migrate Checkout text styles, we can change the base size to be the base style and new-style will not be needed.
export const Checkbox = defineStyleConfig({
    baseStyle: {
        label: {
            textStyle: 'slt-body-text-lg',
            color: 'slt-black.900',
            width: 'full',
        },
        control: {
            width: '16px',
            height: '16px',
            border: '1px solid',
            borderColor: 'slt-black.900',
            borderRadius: '4px',
            _checked: {
                backgroundColor: 'black',
                borderColor: 'black',
                _hover: {
                    bg: 'slt-black.900',
                    borderColor: 'slt-black.900',
                },
            },
            _focus: {
                boxShadow: 'unset',
                outlineStyle: 'solid',
                outlineColor: 'slt-black.900',
                outlineOffset: '1px',
                outlineWidth: '1px',
            },
            _disabled: {
                borderColor: 'slt-black.900',
                borderRadius: '4px',
                backgroundColor: 'white',
                opacity: 0.5,
            },
        },
        icon: {
            fontSize: '10px',
        },
    },
    defaultProps: {
        // Necessary to reset the default size to change the checkbox width/height
        size: '',
    },
    variants: {
        'new-style': newStyle,
    },
    sizes: {
        '': {},
        sm: {
            ...newStyle,
            control: {
                ...newStyle.control,
                marginTop: '2px',
            },
            label: {
                ...newStyle.label,
                textStyle: 'body-small',
            },
        },
        base: {
            ...newStyle,
        },
    },
});
